import React, { useState } from 'react';
import StandardLayout from '../../components/layout/StandardLayout';
import { createCategory } from '../../services/questionAPIService';

const CategoryForm = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newCategory = await createCategory({ name, description });
      console.log('Category created successfully:', newCategory);
      setName('');
      setDescription('');
    } catch (error) {
      console.error('Error creating category:', error);
    }
  };

  return (
    <StandardLayout>
      <div className="w-full mx-auto bg-white p-4 sm:p-8">
        <h1 className="text-2xl font-bold mb-4 text-left">Create New Category</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div>
            <label htmlFor="description" className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
              rows="10"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-auto"
          >
            Create Category
          </button>
        </form>
      </div>
    </StandardLayout>
  );
};

export default CategoryForm;
